angular.module('dnecom')
    .directive('routeHref', ["$parse", function($parse) {
        return {
            link: function(scope, element, attrs) {
                var routeName = attrs.routeHref;
                var routeParams = $parse(attrs.routeHrefParams)(scope);

                element.attr(
                    'href',
                    Routing.generate(routeName, routeParams)
                );
            }
        };
    }]);
